export default __webpack_public_path__ + "static/media/logo-branca.14936ce3.png";